import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"
import { NavigationSlotPortal } from "../NavigationSlotContext"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef(({ className, ...props }, ref) => {
  const layer = props["data-global-nav-layer"] === "2" ? 2 : (props["data-sticky-page-tabs"] ? 3 : null)
  const list = <TabsPrimitive.List data-sticky-page-tabs="" ref={ref} className={cn("inline-flex h-9 items-center justify-start gap-0 rounded-none border-b border-slate-300 bg-slate-100 p-0 text-slate-700", className)} {...props} />
  return layer ? <NavigationSlotPortal layer={layer}>{list}</NavigationSlotPortal> : list
})
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex h-9 items-center justify-center whitespace-nowrap rounded-none border border-transparent border-r-slate-300 px-3 py-1 text-sm font-normal text-slate-700 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-slate-300 data-[state=active]:border-b-white data-[state=active]:border-t-2 data-[state=active]:border-t-sky-600 data-[state=active]:bg-white data-[state=active]:font-semibold data-[state=active]:text-sky-800 data-[state=active]:shadow-none",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
